export interface TransportVehiclePreviewModel {
    id: number;
    name: string;
    licensePlate: string;
    brand: string;
    defaultChauffeur?: string;
    capacity: number;
    baseFarePrice: number;
    farePricePerKm: number;
    remark?: string;
    isActive: boolean;
}

export const DefaultTransportVehiclePreviewModel = () => {
    return {
        id: 0,
        name: '',
        licensePlate: '',
        brand: '',
        defaultChauffeur: undefined,
        capacity: 0,
        baseFarePrice: 0,
        farePricePerKm: 0,
        remark: undefined,
        isActive: true
    } as TransportVehiclePreviewModel
}